import {
  MOTION_GRAPHICS_COLLECTION,
  MUSIC_COLLECTION,
  SFX_COLLECTION,
} from '@music-vine/setlist';

import { buildSearchUrl } from '@/features/SearchPage/utils/searchUrl';
import type { ParsedSearch } from '@/features/GlobalSearch/types/index';
import type { GenericSearchResult } from '@/features/SearchPage/types';
import { log } from '@/lib/utils';

export const parseSearchResults = (
  result: GenericSearchResult
): ParsedSearch => {
  const { type } = result;

  log('result', result);

  // Ensure featured_tags is always an array and each tag has a url
  const featured_tags = Array.isArray(result.featured_tags)
    ? result.featured_tags.map((tag) => ({
        ...tag,
        url: tag.url ?? `/search?search=${encodeURIComponent(tag.name)}&by=tag`,
      }))
    : [];

  switch (type?.toLowerCase()) {
    case 'tracks':
    case 'track':
    case MUSIC_COLLECTION:
      return {
        ...result,
        featured_tags,
        type: 'track',
        secondElem: result.artist ? ` - ${result.artist}` : undefined,
        isTrackItem: true,
      };

    case 'sfx':
    case SFX_COLLECTION: {
      // For SFX, we need to use variant_id if it exists, otherwise fall back to id
      const variantId = result.variant_id ?? result.id;
      const sfxId = result.sfx_id ?? result.id;

      return {
        ...result,
        featured_tags,
        type: 'sfx',
        slug: `/sfx/${result.sfx_slug}/${sfxId}/${variantId}`,
        isTrackItem: true,
      };
    }

    case 'artists':
    case 'artist':
      return {
        ...result,
        featured_tags,
        type: 'artist',
        slug: `/artist/${result.slug}`,
      };

    case 'collections':
      return {
        ...result,
        featured_tags,
        type: 'collection',
      };

    case 'sfxtags':
    case 'tracktags':
      return {
        ...result,
        featured_tags,
        name: result.name ?? 'Unknown',
        slug: result.slug ?? `/search?search=${result.name}&by=tag`,
      };

    case 'sfxqualifiedkeywords':
      return {
        ...result,
        featured_tags,
        name: result.name ?? 'Unknown',
        slug: buildSearchUrl(SFX_COLLECTION, result.name ?? '', {
          by: 'keywords',
        }),
      };
    case 'trackqualifiedkeywords':
      return {
        ...result,
        featured_tags,
        name: result.name ?? 'Unknown',
        slug: buildSearchUrl(MUSIC_COLLECTION, result.name ?? '', {
          by: 'keywords',
        }),
      };
    case MOTION_GRAPHICS_COLLECTION:
      return {
        ...result,
        featured_tags,
        slug: buildSearchUrl(MOTION_GRAPHICS_COLLECTION, result.name ?? ''),
      };
    default:
      return {
        ...result,
        featured_tags,
        name: result.name ?? 'Unknown',
        type,
        slug: `/search?search=${result.name}`,
      };
  }
};
